const Footer = () => {
  return (
    <>
      <footer className="dashbord_footer mt-auto">
  <div className="col-sm-12 text-center">
    {/* Logo section */}
    <div className="footer-logo">
      <img
        src={require('../../assets/img/acachelogo.png')}
        alt="Acache Logo"
        style={{ height: '50px', marginBottom: '10px' }}
      />
    </div>

    {/* Copyright line */}
    <span>
      Copyright © 2025 Acache Technologies Private Limited. All rights reserved.
    </span>
  </div>
</footer>
    </>
  );
};

export default Footer;
